/* Razab About — comparison slider.
   Separate from razab-pages.js so that file stays untouched.
   Everything is opt-in via [data-razab-compare]. */
(function () {
  if (window.__razabAboutExtras) return;
  window.__razabAboutExtras = true;

  function initCompare(root) {
    (root || document).querySelectorAll('[data-razab-compare]').forEach(function (el) {
      if (el.dataset.razabBound) return;
      el.dataset.razabBound = 'true';

      var handle = el.querySelector('[data-razab-compare-handle]');
      var start = parseFloat(el.getAttribute('data-start')) || 50;
      var dragging = false;

      function setSplit(pct) {
        var clamped = Math.max(0, Math.min(100, pct));
        el.style.setProperty('--razab-split', clamped + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(clamped));
      }

      function fromClientX(x) {
        var rect = el.getBoundingClientRect();
        if (!rect.width) return;
        setSplit(((x - rect.left) / rect.width) * 100);
      }

      setSplit(start);

      el.addEventListener('mousedown', function (e) {
        dragging = true;
        fromClientX(e.clientX);
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (dragging) fromClientX(e.clientX);
      });

      window.addEventListener('mouseup', function () {
        dragging = false;
      });

      el.addEventListener(
        'touchstart',
        function (e) {
          dragging = true;
          fromClientX(e.touches[0].clientX);
        },
        { passive: true }
      );

      el.addEventListener(
        'touchmove',
        function (e) {
          if (dragging) fromClientX(e.touches[0].clientX);
        },
        { passive: true }
      );

      el.addEventListener('touchend', function () {
        dragging = false;
      });

      /* Keyboard: arrow keys nudge, home/end jump to either edge. */
      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
          var step = e.shiftKey ? 10 : 2;

          if (e.key === 'ArrowLeft') {
            setSplit(current - step);
          } else if (e.key === 'ArrowRight') {
            setSplit(current + step);
          } else if (e.key === 'Home') {
            setSplit(0);
          } else if (e.key === 'End') {
            setSplit(100);
          } else {
            return;
          }

          e.preventDefault();
        });
      }
    });
  }

  function initAll(root) {
    initCompare(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
